import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {AuthedUrlWrapper} from '../../common/components/AuthedUrlWrapper';
import {Gif} from '../components/Gif';

const MAX_FB_IMG_SIZE = 5 * Math.pow(1024, 2);


export function gifOGMeta(
    gif: api.Post|api.Post[], context: jsx.AppGlobals): Element[] {
    // Not a proper component, since JSX doens't have good support for adjacent
    // elements.
    let collection = false;
    if (Array.isArray(gif)) {
        gif = gif[0] as api.Post;
        collection = true;
    }
    if (!gif || !gif.media_formats) {
        return [];
    }

    let fbImage;
    let media;
    for (const format of ['gif', 'mediumgif', 'tinygif']) {
        media = gif.media_formats[format];
        if (!media) {
            continue;
        }
        // If we already have an image and this one is too small, keep selected
        // format.
        if (fbImage && media.dims[0] < 200 && media.dims[1] < 200) {
            break;
        }
        fbImage = media;
        // If we don't know the size, or if we know the size is OK, keep this
        // format.
        if (!fbImage.size || fbImage.size <= MAX_FB_IMG_SIZE) {
            break;
        }
    }

    const gifUrl = Gif.getFormatUrl(gif, 'gif');
    const ary = [
        <AuthedUrlWrapper url={gifUrl} childrenFunc={(authedGifUrl) => {
            return [collection && <meta
                name="twitter:image"
                content={authedGifUrl}/>,

            <link rel="image_src" href={authedGifUrl}/>].filter((item) => {
                return Boolean(item);
            });
        }}/>,

        <meta property="og:url" content={fbImage.url}/>,
        <meta property="og:description" content="Click to view the GIF"/>,

        <meta
            property="og:type"
            content={collection ? 'website' : 'video.other'}/>,

        <meta property="og:image" content={fbImage.url}/>,
        <meta property="og:image:type" content="image/gif"/>,
        <meta
            property="og:image:width"
            content={fbImage.dims[0].toString()}/>,
        <meta
            property="og:image:height"
            content={fbImage.dims[1].toString()}/>,
    ];

    const mp4 = gif.media_formats.mp4;

    if (mp4?.url) {
        ary.push(
            <meta property="og:video" content={mp4.url}/>,
            <meta property="og:video:secure_url" content={mp4.url}/>,
            <meta property="og:video:type" content="video/mp4"/>,
        );
        if (mp4.dims) {
            ary.push(
                <meta
                    property="og:video:width"
                    content={mp4.dims[0].toString()}/>,
                <meta
                    property="og:video:height"
                    content={mp4.dims[1].toString()}/>,
            );
        }
    }

    const webm = gif.media_formats.webm;

    if (webm?.url) {
        ary.push(
            <meta property="og:video" content={webm.url}/>,
            <meta property="og:video:secure_url" content={webm.url}/>,
            <meta property="og:video:type" content="video/webm"/>,
        );
        if (webm.dims) {
            ary.push(
                <meta
                    property="og:video:width"
                    content={webm.dims[0].toString()}/>,
                <meta
                    property="og:video:height"
                    content={webm.dims[1].toString()}/>,
            );
        }
    }

    return ary.filter((item) => {
        return Boolean(item);
    });
}
